import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function KromaIcon() {
    return (_jsxs("svg", { className: "ui-size-full", viewBox: "0 0 23 22", fill: "currentColor", children: [_jsx("path", { d: "M11.7604 0.156006L0.76001 7.18328L6.2598 10.6977L11.7604 7.18328L17.2603 10.6977L22.76 7.18328L11.7604 0.156006Z" }), _jsx("path", { d: "M22.76 7.18364L11.7604 14.2117L0.76001 7.18364V14.2117L11.7604 21.2397L22.76 14.2117V7.18364Z" })] }));
}
export default KromaIcon;
